import { hrApiClient } from '@/lib/api';
import { IPrice } from '@/shared';

export const getPrices = async (groupId: number) => {
  return await hrApiClient.get<IPrice[]>(`price/prices`, {
    params: { groupId },
  });
};

export const getPrice = async (groupId: number, itemId?: number) => {
  return await hrApiClient.get<IPrice>(`price/priceById`, {
    params: {
      groupId,
      ...(itemId ? { itemId } : {}),
    },
  });
};
